import useAuth from "../../hooks/useAuth";

import Hero from "../../components/home/Hero";
import FeaturedEvents from "../../components/home/FeaturedEvents";
import HowItWorks from "../../components/home/HowItWorks";
import OrganizerProducts from "../../components/home/OrganizerProducts";
import EventSearchBar from "../../components/home/EventSearchBar";

export default function Home() {
  const { user, loading } = useAuth();
  console.log("AUTH:", { loading, user });

  return (
    <>
      <Hero />
      <EventSearchBar />
      <FeaturedEvents />
      <HowItWorks />
      <OrganizerProducts />
    </>
  );
}
